import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {useForceUpdate, useSyncEvent} from '@containers/hooks'
import {globals} from '@extensions/globals-base'
import {MenuIconButtonWithTooltip} from '../components/menu-icon-button-with-tooltip'
import {useMainMenuStore} from '../main-menu-store'

export const OpenMenuItem = observer(() => {
  const [state, store] = useMainMenuStore()
  const forceUpdate = useForceUpdate()
  useSyncEvent(
    'profile',
    {debounceTime: 50, filter: globals.currentUserId},
    () => {
      forceUpdate()
    }
  )
  const toggleMenu = () => store.setMenuOpen(!state.menuOpen)

  return (
    <MenuIconButtonWithTooltip
      icon="IconLayoutSidebarLeftExpand"
      hint={Lang.msg.menu.openMenuHint}
      onClick={toggleMenu}
      className="mb-8"
    />
  )
})
